module.exports.initialOrder = {
  balanceAmount: 0,
  cashewCustomerId: 0,
  currencyCode: 'AED',
  discounts: [],
  disputeClose: false,
  id: 0,
  items: [],
  metaData: {},
  orderReference: '',
  shopifyReference: '',
  orderStatus: 'CREATED',
  refundStatus: null,
  orderUrl: {
    cancelUrl: '',
    confirmationUrl: '',
    id: '',
  },
  purchaseDate: new Date(),
  storeId: 0,
  taxAmount: 0,
  totalAmount: 0,
  bankId: 0,
  merchantOrderCode: '',
};
